import { isEmptyObject } from "../../../utils/tests";
import { LmpMatchCommentsQuery, LmpMatchCommentsSubscription } from '../types';

/**
 * typeguard for LmpMatchCommentsQuery
 * @param LmpMatchCommentsQuery object passed to transformer
 */
export const isValidLmpMatchCommentsQuery = (obj: LmpMatchCommentsQuery): boolean => Boolean(obj?.data?.getMatchComments && !isEmptyObject(obj.data.getMatchComments));


/**
 * typeguard for LmpMatchCommentsSubscription
 * @param LmpMatchCommentsSubscription object passed to transformer
 */
export const isValidLmpMatchCommentsSubscription = (obj: LmpMatchCommentsSubscription): boolean => Boolean(obj?.data?.onUpdateMatchCommentsByMatchIdAndPage && !isEmptyObject(obj.data.onUpdateMatchCommentsByMatchIdAndPage));

